import { useEffect } from 'react';
import { useBreadcrumbs } from '../context/BreadcrumbsContext';

/**
 * Hook personnalisé pour enregistrer automatiquement les mappings ID → nom
 * @param {string} id - L'ID à mapper
 * @param {string} name - Le nom à utiliser
 * @param {string} type - Le type d'entité (customer, capsule, selection, etc.)
 * @param {boolean} enabled - Si le mapping doit être activé
 */
export const useBreadcrumbMapping = (id, name, type = 'default', enabled = true) => {
  const { registerIdMapping } = useBreadcrumbs();

  useEffect(() => {
    if (enabled && id && name) {
      registerIdMapping(id, name, type);
    }
  }, [id, name, type, enabled, registerIdMapping]);
};

export default useBreadcrumbMapping; 